import { 
    Snackbar,
    Grid, 
    Chip, 
    Divider, 
    Tab, 
    Tabs, 
    Box, 
    Accordion, 
    AccordionSummary, 
    AccordionDetails, 
    ListItemIcon, 
    List, 
    ListItem, 
    ListItemText, 
    TextField, 
    IconButton, 
    InputBase, 
    Paper, 
    Alert, 
    Select, 
    FormControl, 
    FormControlLabel,
    FormLabel,
    FormGroup,
    MenuItem, 
    Container, 
    Typography, 
    ButtonGroup, 
    Button, 
    Stack,
    Fab,
    CircularProgress, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle, 
    Radio,
    RadioGroup,
    AppBar,
    Toolbar,
    Table,
    TableContainer,
    TableBody,
    TableRow,
    TableCell,
    Card,
    CardMedia,
    CardContent,
    CssBaseline,
    FormHelperText,
    Switch,
    Slider,
} from '@mui/material';

import { grey } from '@mui/material/colors';

import EditDocumentIcon from '@mui/icons-material/EditDocument';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import HistoryIcon from '@mui/icons-material/History';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import MenuIcon from '@mui/icons-material/Menu';
import DirectionsIcon from '@mui/icons-material/Directions';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import InfoIcon from '@mui/icons-material/Info';

import { styled } from '@mui/material/styles';

export default { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon };